import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function Placeholder({
  className,
  data = false,
}: {
  className: string
  data?: boolean
}): React.JSX.Element {
  return (
    <div
      className={cn(
        'animate-pulse bg-gray-100 dark:bg-white/10',
        data ? 'h-[1.0em] rounded' : 'rounded-xl',
        className,
      )}
    />
  )
}

export function Data({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}): React.JSX.Element {
  return <div className={cn('flex h-[1lh] items-center', className)}>{children}</div>
}
